import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Instagram, Mail } from 'lucide-react';
const WHATSAPP_URL = 'https://wa.me/5491130922538';
const INSTAGRAM_URL = 'https://instagram.com/buceoynavegacion';
const EMAIL_URL = 'mailto:buceoynavegacion@gmail.com';
const socials = [{
  label: 'WhatsApp',
  href: WHATSAPP_URL,
  Icon: MessageCircle,
  external: true
}, {
  label: 'Instagram',
  href: INSTAGRAM_URL,
  Icon: Instagram,
  external: true
}, {
  label: 'Correo electrónico',
  href: EMAIL_URL,
  Icon: Mail,
  external: false
}];
export function ContactoFinal() {
  return <section className="py-24 sm:py-28 px-6 bg-brand-background relative overflow-hidden" data-id="element-68">
      <div className="max-w-2xl mx-auto relative z-10" data-id="element-69">
        {/* Closing phrase */}
        <motion.h2 initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="text-center text-white font-heading font-black text-3xl sm:text-4xl md:text-5xl uppercase tracking-tight leading-tight mb-12 sm:mb-16" data-id="element-70">
          Tu historia también forma
          <br className="hidden sm:block" data-id="element-71" /> parte de la nuestra.
        </motion.h2>

        {/* Premium floating card */}
        <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        y: 0,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="relative" data-id="element-72">
          <motion.div animate={{
          y: [0, -8, 0]
        }} transition={{
          duration: 5,
          ease: 'easeInOut',
          repeat: Infinity
        }} className="rounded-[2rem] border border-brand-primary/25 bg-brand-dark px-8 py-12 sm:px-12 sm:py-14 text-center shadow-[0_30px_80px_-25px_rgba(0,0,0,0.8)]" data-id="element-73">
            {/* Subtle inner depth glow */}
            <div className="pointer-events-none absolute inset-0 rounded-[2rem] [background:radial-gradient(110%_70%_at_50%_0%,rgba(0,184,217,0.10)_0%,transparent_60%)]" data-id="element-74" />

            <div className="relative" data-id="element-75">
              <h3 className="text-white font-heading font-black text-2xl sm:text-3xl uppercase tracking-tight mb-5" data-id="element-76">
                Buceo y Navegación
              </h3>
              <div className="text-brand-details/90 text-sm sm:text-base font-light space-y-1 mb-10" data-id="element-77">
                <p data-id="element-78">Escuela de Buceo</p>
                <p data-id="element-79">Viajes Grupales</p>
                <p data-id="element-80">Agencia de Turismo HC 26.614</p>
              </div>

              {/* Circular social buttons */}
              <div className="flex items-center justify-center gap-5 mb-10" data-id="element-81">
                {socials.map(({
                label,
                href,
                Icon,
                external
              }) => <motion.a key={label} href={href} {...external ? {
                target: '_blank',
                rel: 'noopener noreferrer'
              } : {}} aria-label={label} whileHover={{
                scale: 1.12,
                y: -3
              }} whileTap={{
                scale: 0.94
              }} transition={{
                type: 'spring',
                stiffness: 400,
                damping: 18
              }} className="w-14 h-14 rounded-full border border-brand-primary/40 bg-brand-primary/10 flex items-center justify-center text-brand-primary hover:bg-brand-primary/20 hover:border-brand-primary/70 transition-colors" data-id="element-82">
                    <Icon size={24} strokeWidth={2} data-id="element-83" />
                  </motion.a>)}
              </div>

              {/* Primary CTA */}
              <motion.a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} transition={{
              type: 'spring',
              stiffness: 400,
              damping: 22
            }} className="block w-full bg-gradient-to-r from-[#00B8D9] to-[#4FC3F7] text-[#031D33] font-bold uppercase tracking-widest py-4 px-8 rounded-full shadow-[0_10px_30px_-5px_rgba(0,184,217,0.45)]" data-id="element-84">
                Hablar por WhatsApp
              </motion.a>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}